import { DSCredit } from 'shared-definitions/types'
import { ApiCreditProps } from 'data-source/types.wp'
import { pLinkMapper, PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'

export function creditMapper(subInput: ApiCreditProps, opts: PLinkMapperOpts): DSCredit {
  return {
    title: subInput.text,
    pLink: subInput.url ? pLinkMapper(subInput.url, opts) : null,
  }
}
